var StitchAuthResponseCredential = (function () {
    function StitchAuthResponseCredential(authInfo, providerType, providerName, asLink) {
        this.authInfo = authInfo;
        this.providerType = providerType;
        this.providerName = providerName;
        this.asLink = asLink;
    }
    return StitchAuthResponseCredential;
}());
export default StitchAuthResponseCredential;
//# sourceMappingURL=StitchAuthResponseCredential.js.map